import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Area } from 'src/app/shared/models/area';

@Component({
	selector: 'app-detail-area',
	templateUrl: './detail-area.component.html',
	styleUrls: ['./detail-area.component.scss']
})
export class DetailAreaComponent implements OnInit {
	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp(
		"^[0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+( [0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+)*$"
	);

	area: Area = null;
	confirmDeleteModalRef: BsModalRef;
	isDeletable: boolean;

	isFormReadOnly = true;

	areaDetailForm = new FormGroup({
		name: new FormControl('', [
			Validators.required
		]),
		description: new FormControl('', Validators.maxLength(255))
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService
	) {}

	ngOnInit(): void {
		this.isDeletable = this.facade.dataStorageService.isPlanificatrice();
		const id = +this.route.snapshot.paramMap.get('id');
		this.facade.areaService.getAreaById(id).subscribe({
			next: (area: Area) => {
				this.area = area;
				this.resetForm();
			},
			error: (err: ErrorResponse) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.goBack();
			}
		});
	}

	goBack(): void {
		this.router.navigate(['/gestion/areas/list']);
	}

	delete(area: any): void {
		if (this.isDeletable) {
			this.facade.areaService.deleteArea(this.area.id).subscribe({
				complete: () => {
					this.modalService.hide();
					this.goBack();
				},
				error: (err: ErrorResponse) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.goBack();
				}
			});
		}
	}

	openConfirmDeleteModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	editForm() {
		this.isFormReadOnly = false;
	}

	stopEditForm(isSubmit: boolean) {
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;
		this.resetForm();
	}

	onSubmit() {
		if (this.areaDetailForm.valid) {
			this.isValidateButtonClicked.value = true;
			//const userCenter =
				//this.facade.dataStorageService.getUser()?.employee.serviceCenter;
			//this.area.serviceCenter = userCenter;

			this.facade.areaService.updateArea(this.area).subscribe({
				complete: () => {
					this.stopEditForm(true);
				},
				error: () => {
					this.stopEditForm(true);
					// On va chercher la nouvelle version de l'employé
					this.facade.areaService
						.getAreaById(this.area.id)
						.subscribe((area: Area) => {
							this.area = area;
						});
				}
			});
		} else {
			this.isValidateButtonClicked.value = false;
		}
	}

	resetForm() {
		this.areaDetailForm.reset();
		this.areaDetailForm.setValue({
			name: this.area.name,
			description: this.area.description
		});
	}
}
